"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MatchingEditorTopMenuBarModule = /** @class */ (function () {
    function MatchingEditorTopMenuBarModule() {
    }
    return MatchingEditorTopMenuBarModule;
}());
exports.MatchingEditorTopMenuBarModule = MatchingEditorTopMenuBarModule;
